export const getChatName = (message) => {
  const userMessage = message.split(" ");
  if (userMessage.length > 2) return userMessage.slice(0, 3).join(" ");
  return message;
};
